import { render } from "./ResumeComp.vue?vue&type=template&id=3d18fd86"
import script from "./ResumeComp.vue?vue&type=script&lang=js"
export * from "./ResumeComp.vue?vue&type=script&lang=js"

import "./ResumeComp.vue?vue&type=style&index=0&id=3d18fd86&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__